/**
 * Inyeccion del `PuertoReservas` en el arbol de React.
 *
 * La interfaz publica nunca importa Firebase: recibe el puerto por contexto. En
 * produccion lo construye `main.tsx` con `puertoFirebase`; en las pruebas se inyecta un
 * doble en memoria. Ese es el motivo por el que el flujo publico entero se puede probar
 * sin emuladores, sin red y en milisegundos.
 */

import { createContext, use } from 'react';

import type { PuertoReservas } from '@/infra/contratos';

export const ContextoPuerto = createContext<PuertoReservas | null>(null);

/**
 * Devuelve el puerto inyectado. Falla ruidosamente si falta el proveedor.
 *
 * Se llama `usePuerto` y no `usarPuerto` porque es un hook: React —y la regla
 * `rules-of-hooks`— identifican los hooks por el prefijo `use`. El resto del nombre sigue
 * en espanol, como el vocabulario del dominio (ADR-036).
 */
export function usePuerto(): PuertoReservas {
  const puerto = use(ContextoPuerto);
  if (puerto === null) {
    throw new Error(
      'Falta <ContextoPuerto.Provider>. La interfaz publica necesita un PuertoReservas inyectado.',
    );
  }
  return puerto;
}
